import moment from "moment";

export const felonyConsideration = ({
  convicted_of_felony,
  convictionMonth,
  convictionYear,
  releaseMonth,
  releaseYear,
}) => {
  const convictionMoment = moment(`${convictionYear}-${convictionMonth}-01`);
  const releaseMoment = moment(`${releaseYear}-${releaseMonth}-01`);
  const monthsSinceConviction = moment
    .duration(moment() - convictionMoment)
    .asMonths();
  const monthsSinceRelease = moment
    .duration(moment() - releaseMoment)
    .asMonths();
  return (
    convicted_of_felony === "yes" &&
    (monthsSinceConviction <= 13 || monthsSinceRelease <= 13)
  );
};



// WEBPACK FOOTER //
// ./src/utils/surveyLogic.js